import { Box, Paper, Typography, IconButton, Button, Stack } from "@mui/material";
import { useState } from "react";
import { CloseIcon } from "../../../minimals/theme/overrides/CustomIcons";
import SalesRepForm from "./SalesRepForm";
import { InternalUser } from "../../types/app";

type Props = {
  onClose: () => void;
  salesReps: (InternalUser | null)[];
  marketingReps: (InternalUser | null)[];
  onSubmit: (reps: (InternalUser | null)[]) => void;
};

const ChooseSalesRepsManuallyForm = ({ onClose, salesReps, marketingReps, onSubmit }: Props) => {
  const [selectedReps, setSelectedReps] = useState<(InternalUser | null)[]>([null, null, null]);

  const renderRepsList = (reps: (InternalUser | null)[]) => (
    <Stack spacing={1}>
      {reps
        .filter((rep): rep is InternalUser => rep !== null && Boolean(rep.fullName))
        .map((rep, idx) => (
          <Typography key={idx} variant="body2">
            {rep.fullName}
          </Typography>
        ))}
    </Stack>
  );

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "rgba(15,23,42,0.45)",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        pt: 5,
        zIndex: 1300
      }}
    >
      <Paper sx={{ width: "min(1100px, 95vw)", borderRadius: 2, overflow: "hidden", boxShadow: 6 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Choose a Sales Rep manually to write to the Order
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Typography
          variant="body2"
          sx={{ color: "#b71c1c", px: 2, py: 1, borderBottom: "1px solid", borderColor: "divider" }}
        >
          (Use the form below to select from scratch)
        </Typography>

        <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, p: 2 }}>
          <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
            <Box
              sx={{ bgcolor: "#F3F5FF", p: 2, borderBottom: "1px solid", borderColor: "divider", minHeight: "50px" }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Existing Sales Reps from Marketing Sources of Selected Orders:
              </Typography>
            </Box>
            <Box sx={{ p: 2 }}>{renderRepsList(salesReps)}</Box>
          </Paper>

          <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
            <Box
              sx={{ bgcolor: "#F2FCF7", p: 2, borderBottom: "1px solid", borderColor: "divider", minHeight: "50px" }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Submitted Sales Reps from Phonebook:
              </Typography>
            </Box>
            <Box sx={{ p: 2 }}>{renderRepsList(marketingReps)}</Box>
          </Paper>
        </Box>

        <Box sx={{ px: 2, pt: 1, pb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
            Manually Select Sales Reps:
          </Typography>
          <SalesRepForm salesReps={selectedReps} setSalesReps={setSelectedReps} />
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => onSubmit(selectedReps)}
              disabled={selectedReps.filter(Boolean).length === 0}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ChooseSalesRepsManuallyForm;
